import { useCallback } from "react";
import confetti from "canvas-confetti";

export function usePawConfetti() {
  return useCallback(() => {
    const defaults = {
      origin: { y: 0.6 },
      colors: ["#E8A0B4", "#D4A853", "#C4728A", "#F0E0E5", "#FDF8F5"],
      shapes: ["circle"],
      scalar: 1.2,
      zIndex: 9999,
    };

    confetti({ ...defaults, particleCount: 15, spread: 26, startVelocity: 55 });
    confetti({ ...defaults, particleCount: 12, spread: 60 });
    confetti({
      ...defaults,
      particleCount: 20,
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });
    confetti({
      ...defaults,
      particleCount: 8,
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
    });

    setTimeout(() => confetti.reset(), 1500);
  }, []);
}
